import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/authContext';

function Navbar({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="header-professional">
      <div className="header-container">
        {/* Brand (always visible) */}
        <div className="header-brand">
          <div className="brand-logo">
          <img
            src="/logo.png"
            alt="Logo"
            style={{ height: "4em", width: "auto", display: "inline-block" }}
          />          </div>
          <div className="brand-text">
            <Link to="/">
              <h1>YieldMap</h1>
            </Link>
            <span className="brand-subtitle">Multi-Family Investment Platform</span>
          </div>
        </div>

        {/* Everything else (stats + buttons) injected from page */}
        {children}

        {/* User menu on the far right */}
        <div className="header-user-menu">
          <button
            className="user-menu-button"
            onClick={() => setMenuOpen(open => !open)}
          >
            <span>{user?.display_name || user?.email || 'Account'}</span>
            <span className="user-menu-caret">▾</span>
          </button>
          {menuOpen && (
            <div className="user-menu-dropdown">
              { (isAdmin) && (              
                <button onClick={() => { navigate('/admin-console'); setMenuOpen(false); }}>
                  Admin console
                </button>)
              }
              <button onClick={() => { navigate('/settings'); setMenuOpen(false); }}>
                Settings
              </button>
              <button onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;
